<div class="app-layout-no-sidenav">
  <div
    class="app-layout-no-sidenav__slide"
    [ngClass]="{
      'app-layout-no-sidenav__slide--close': !sideNavHelpOpen(),
      'app-layout-no-sidenav__slide--open': sideNavHelpOpen(),
    }"
  >
    <div class="app-layout-no-sidenav__side-panel app-layout-no-sidenav__side-panel--expanded">
      <ftr-side-nav-shell
        [displayMode]="sideNavMode()"
        [expanded]="true"
        [isLoading]="false"
        [isOpened]="sideNavHelpOpen()"
        [footerItems]="[helpBranchItem()]"
        [showBranchBackButton]="false"
        theme="dark"
        [helpMenuConfig]="{ mode: 'loggedout' }"
        (sideBarToggled)="toggleHelpNavMenu(false)"
      />
    </div>
    <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -- the backdrop should not be focusable -->
    <div class="app-layout-no-sidenav__slide-backdrop" (click)="toggleHelpNavMenu(false)"></div>
  </div>
  <ftr-header-logged-out [displayMode]="sideNavMode()" (helpButtonClicked)="toggleHelpNavMenu(true)" />
  <div class="app-layout-no-sidenav__content-wrapper">
    <main
      id="main-content"
      [ngClass]="[
        appContentWindowSelector,
        !routeData()?.whiteBackground ? appContentWindowSelectorGreyBackground : '',
      ]"
      cdkScrollable
    >
      <ng-content />
    </main>
  </div>
  <ftr-footer-logged-out />
</div>
